/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
import Component from "@glimmer/component";
const NonSmallCellCancerTypes = ["adenocarcinoma", "squamous-cell-carcinoma", "large-cell-carcinoma"];
const mutations = ["brca1", "brca2", "alk", "ros1", "egfr", "met", "her2", "braf", "kras", "stk11"];
export default class MedicalHistoryFormLungCancerPathologyComponent extends Component {
  get nonSmallCellCancerTypes() {
    return NonSmallCellCancerTypes;
  }
  get mutations() {
    return mutations;
  }
}